import { getUser } from "./authService";
import http, { host } from "./httpService";
import { standerdDate, standerdDateForDataCreation } from "../utils/dataFilter";

export const getDailyContainerPlanningAB = async (date) => {
  return await http.get(host + "GetDailyContainerPlanningData_AB", {
    params: { fromdate: date },
  });
};

export const getMonthlyContainerPlanning = async (month) => {
  return await http.get(host + "GetMonthlyContainerPlanningData_JD", {
    params: { planningMonth: month },
  });
};

export const getDailyContainerPlanning = async (month) => {
  return await http.get(host + "GetDailyTractorShipmentActualData", {
    params: { _jdmonth: month },
  });
};
export const getDailyContainerPlanningCarrier = async (month, carrier) => {
  return await http.post(
    host + "GetDailyTractorShipmentSummaryByCarrier",
    {
      PlanningDate: month,
      Carrier: carrier,
    }
  );
};



export const getMonthlyShipmentActualProgress = async (data) => {
  const response =  await http.get(host + "GetMonthShipmentProgress", {
    params: { _date: data },
  });
  return response.data.map((item)=>{
    return{
      ...item,
      date : standerdDate(item.date)
    }
  })
};

export const DetailedMonthlyTractorShipmentActualData = async (data) => {
  const response =  await http.get(host + "GetMonthlyTractorShipmentActualData", {
    params: { _planningDate: data },
  });
  return response.data.map((item)=>{
    return{
      ...item,
      Date : standerdDateForDataCreation(item.Date)
    }
  })
};

export const getMonthlyShipmentActualProgressForAggregate = async (data) => {
  const response =  await http.get(host + "GetMonthShipmentProgressAggregate", {
    params: { _date: data },
  });
  return response.data.map((item)=>{
    return{
      ...item,
      date : standerdDate(item.date)
    }
  })
};

export const getMonthlyShipmentActualProgressFor5M = async (data) => {
  const response =  await http.get(host + "GetMonthShipmentProgress5M", {
    params: { _date: data },
  });
  return response.data.map((item)=>{
    return{
      ...item,
      date : standerdDate(item.date)
    }
  })
};

export const getWeeklyPlan = async (month, type) => {
  return await http.get(
    host + "GetMarketWiseWeeklyContainerPlanningFromMonthlySheetJD_AB",
    { params: { planningMonth: month, Type: type } }
  );
};

export const insertBookingNumber = async ({
  DailyContainerPlanningId,
  BookingNo,
  BookedBy,
}) => {
  const formData = new FormData();
  formData.append("DailyContainerPlanningId", DailyContainerPlanningId);
  formData.append("BookingNo", BookingNo);
  formData.append("BookedBy", BookedBy);
  return await http.post(
    host + "AddBookingNumberForDailyContainerPlanning",
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
};

export const insertBulkTractorBookingNumber = async (data) => {
  return await http.post(host + "AddTractorBulkBooking", {_jsonTrBookingList : data})
}

export const updateBulkTractorBookingNumberWithReason = async (data) => {
  return await http.put(host + "UpdateBulkTractorBookingNumberWithReason", {_jsonTractorNowithReason : data})
}

export const updateBookingNumber = async ({
  AssignContainerId,
  BookingNo,
  BookedBy,
}) => {
  const formData = new FormData();
  formData.append("assignContainerPlanningId", AssignContainerId);
  formData.append("bookingNo", BookingNo);
  formData.append("bookedBy", BookedBy);
  return await http.put(
    host + "UpdateBookingNumberForDailyContainerPlanning",
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
};

export const updateTractorContainer = async (formData) => {
  return await http.put(host + "UpdateTractorContainerNumber", formData);
};

export const updateTractorBulkContainer = async (data) => {
  return await http.put(host + "UpdateTractorBulkContainerNumber", data);
};

export const getReasonsForErrorInShipmentBooking = async () => {
  return await http.get(host + "GetReasonMasterDetails");
};

export const sendReasonsToJD = async ({
  DailyContainerPlanningId,
  Reason,
  manualReason,
  SendApprovalBy,
}) => {
  if(Reason === "" && manualReason !== ""){
    const formData = new FormData();
    formData.append("DailyContainerPlanningId", DailyContainerPlanningId);
    formData.append("Reason", `${manualReason}`);
    formData.append("SendApprovalBy", SendApprovalBy);
    return await http.post(host + "AddSendReasonToJD", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
  else if(Reason !== "" && manualReason !== ""){
    const formData = new FormData();
    formData.append("DailyContainerPlanningId", DailyContainerPlanningId);
    formData.append("Reason", `${Reason},${manualReason}`);
    formData.append("SendApprovalBy", SendApprovalBy);
    return await http.post(host + "AddSendReasonToJD", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }else{
    const formData = new FormData();
    formData.append("DailyContainerPlanningId", DailyContainerPlanningId);
    formData.append("Reason", Reason);
    formData.append("SendApprovalBy", SendApprovalBy);
    return await http.post(host + "AddSendReasonToJD", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
};

export const updateReasonsToJD = async ({
  AssignContainerPlanningId,
  Reason,
  manualReason,
  SendApprovalBy,
}) => {
  if(Reason === "" && manualReason !== ""){
    let updatingData = {
      AssignContainerPlanningId:AssignContainerPlanningId,
      Reason : manualReason,
      SendApprovalBy
    }
    return await http.put(host + "UpdateReasonForDailyContainerPlanning",updatingData);
  }
  else if(Reason !== "" && manualReason !== ""){
    let updatingData = {
      AssignContainerPlanningId:AssignContainerPlanningId,
      Reason : `${Reason},${manualReason}`,
      SendApprovalBy
    }
    return await http.put(host + "UpdateReasonForDailyContainerPlanning", updatingData);
  }else{
    let updatingData = {
      AssignContainerPlanningId:AssignContainerPlanningId,
      Reason : `${Reason}`,
      SendApprovalBy
    }
    return await http.put(host + "UpdateReasonForDailyContainerPlanning", updatingData);
  }
};

export const sendBulkReasonsToJD = async (data) => {
  // const formData = new FormData();
  // formData.append("DailyContainerPlanningId", DailyContainerPlanningId);
  // formData.append("Reason", Reason);
  // formData.append("SendApprovalBy", SendApprovalBy);
  return await http.post(host + "InsertBulkTractorBookingReason", {_jsonTracBookingReson: data});
};

export const sendBulkReasonsforhold= async (data) => {
  // const formData = new FormData();
  // formData.append("DailyContainerPlanningId", DailyContainerPlanningId);
  // formData.append("Reason", Reason);
  // formData.append("SendApprovalBy", SendApprovalBy);
  return await http.put(host + "UpdateBulkHoldStatus_Aryabhatta", {_jsonUpdateBulkHoldStatus_AryabhattaList: data});
};


export const responseFromJD = async ({
  assignContainerId,
  DeereStatus,
  DeereStatusBy,
}) => {
  const formData = new FormData();
  formData.append("assignContainerId", assignContainerId);
  formData.append("DeereStatus", DeereStatus);
  formData.append("DeereStatusBy", DeereStatusBy);
  return await http.put(host + "UpdateResponseFromJD", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const createMonthlyPlan = async (plan) => {
  return await http.post(host + "AddMonthlyContainerPlanningData", {
    _jsonmonthlylist: plan,
  });
};

export const createDailyPlan_AB = async (plan) => {
  return await http.post(host + "AddDailyContainerPlanningData", {
    _jsonDailyContainerPlanninglist: plan,
  });
};

export const getCountryWiseWeeklyPlan = async (month) => {
  return await http.get(
    host + "GetCountryContainerWiseWeeklyContainerPlaningData",
    { params: { planningMonth: month } }
  );
};

export const getContainerswapdata = async (payload) => {
  return await http.get(
    host + "GetContainerDiversion_new",
    {params: {Type: payload.type,
      Date:payload.date,
      Screen:payload.screen }}
  );
};

export const updateContainerSwapData = async (payload) => {
  return await http.put(
    host + "UpdateContainerDiversionData_Aryabhatta",
    payload
  );
};

export const getMarketWiseWeeklyPlan = async (month) => {
  return await http.get(host + "GetMarketWiseWeeklyContainerPlaningData", {
    params: { planningMonth: month },
  });
};

export const updateTractorShipment = async (data) => {
  const formData = new FormData();
  formData.append("Id", data.DailyContainerPlanningId);
  formData.append("ColumnName", data.ColumnName);
  formData.append("PrevVal", data.PreviousValue);
  formData.append("Value", data.Value);
  formData.append("UserId", getUser().uid);
  return await http.put(host + "UpdateSingleRowforTractor", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const updateTractorShipmentForInspection = async (data) => {
  const dataObj = {
    id: data.DailyContainerPlanningId,
    columnName: data.ColumnName,
    prevVal: data.PreviousValue,
    value: data.Value,
  };
  return await http.put(host + "updateSingleRowforTractorInspection", dataObj);
};

export const uploadTractorSIDoc = async (month, formData) => {
  return await http.post(host + `AddSIDocument?DocDate=${month}`, formData);
};

export const getTractorSIDoc = async (data) => {
  return await http.get(host + "GetSiDocDetails", {
    params: { Date: data },
  });
};

export const viewSIDoc = async (data) => {
  return await http.get(host + "ViewSiDocFile",{params:{FileName : data}})
}

export const updateSIDoc = async (id, formData) => {
  return await http.put(host + `UpdateSIDocument?DocId=${id}`, formData);
};

export const uploadTractorBookingDocument = async (
  formData,
  dailyBookingId
) => {
  return await http.put(
    host + `UpdateBookingDocumentTractor?assignContainerId=${dailyBookingId}`,
    formData
  );
};

export const insertTractorPlanningDetailInfo = async (data) => {
  return await http.post(host + "AddTractorDailyPlanningDetailedInfo", {
    _jsonTractorDailyPlanningInfoList: data,
  });
};

export const insertAggregatePlanningDetailInfo = async (data) => {
  return await http.post(host + "AddAggregateDailyPlanningDetailedInfo", {
    _jsonAggregateDailyPlanningInfoList: data,
  });
};

export const insert5MPlanningDetailInfo = async (data) => {
  return await http.post(host + "AddDailyPlanning5mDetailedInfo", {
    _jsonDailyplan5MInfolist: data,
  });
};

export const GetTractorDailyPlanningDataForSubrow = async (data) => {
    const response = await http.get(
      host + "GetTractorDailyPlanningDetailedInfo",
      { params: { dailyContainerPlanningId: data } }
    );
    return response.data.map((item) => {
      return {
        ...item,
        ETA: standerdDate(item.ETA),
        ETD: standerdDate(item.ETD),
        Factory_In_Date: standerdDate(item.Factory_In_Date),
        Factory_Out_Date: standerdDate(item.Factory_Out_Date),
        JD_Stuffing_Date: standerdDate(item.JD_Stuffing_Date),
        Origin_Transit_Time: `${item.Origin_Transit_Time} days`,
        Ground_Rent_Days: `${item.Ground_Rent_Days} days`,
        Approx_container_detention: `${item.Approx_container_detention} days`,
      };
    });
};

export const GetTractorDailyPlanningData = async (data) => {
  var planningDataArray = []
  for (let i = 0; i < data.length; i++) {
    const response = await http.get(
      host + "GetTractorDailyPlanningDetailedInfo",
      { params: { dailyContainerPlanningId: data[i] } }
    );
    for (let i = 0; i < response.data.length; i++) {
      planningDataArray.push({
        ...response.data[i],
        ETA: standerdDate(response.data[i].ETA),
        ETD: standerdDate(response.data[i].ETD),
        Factory_In_Date: standerdDate(response.data[i].Factory_In_Date),
        Factory_Out_Date: standerdDate(response.data[i].Factory_Out_Date),
        JD_Stuffing_Date: standerdDate(response.data[i].JD_Stuffing_Date),
        Origin_Transit_Time: `${response.data[i].Origin_Transit_Time} days`,
        Ground_Rent_Days: `${response.data[i].Ground_Rent_Days} days`,
        Approx_container_detention: `${response.data[i].Approx_container_detention} days`,
      })
    }
  }
  return planningDataArray
};

export const deleteTractorShipmentById = async (data, action) => {
  return await http.delete(host + "DeleteTractorDailyPlanWithId", {params:{Id : data, _DeleteforTrans : action}})
}

export const AddTransporter = async (data) => {
  return await http.post(host + "AddTransporter" ,{_jsonTransmiterList:[{Email: data.Email, TransporterName: data.TransporterName, Type: data.Type}]})
}

export const deleteTractorDailyPlan = async (date, action) => {
  return await http.delete(host + 'DeleteAryabhattaTractorDailyPlan', {params: {_date : date, _DeleteforTrans : action}})
}

export const deleteTractorMonthlyPlan = async (date) => {
  return await http.delete(host + 'DeleteTractorMonthlyPlan', {params: {_PlanningMonth : date}})
}

export const getMaxTractorContainerCount = async (date) => {
  return await http.get(host + "GetMaximumContainerCountTractor", {params:{_date:date}})
}

export const updateBookingNumTractor = async (data) =>{
  const formData = new FormData();
  formData.append("assignContainerPlanningId", data.assignContainerPlanningId);
  formData.append("bookingNo", data.bookingNo);
  formData.append("bookedBy", data.bookedBy);
  return await http.put(
    host + "UpdateBookingNumberForDailyContainerPlanning",
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
}

export const updateTractorBulkData = async (data) => {
  await http.put(host + "UpdateBulkDataForTractor", {_jsonTracBookingUpList:data})
}

 export const getCarrierMasterDropDown = async () => {
  return await http.get(host + "GetUniqueCarriers");
};

